import { render, staticRenderFns } from "./DocumentoForm.vue?vue&type=template&id=29e11842&scoped=true&lang=pug&"
import script from "./DocumentoForm.vue?vue&type=script&lang=js&"
export * from "./DocumentoForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentoForm.vue?vue&type=style&index=0&id=29e11842&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e11842",
  null
  
)

export default component.exports